import React from "react";
import KickImage from 'Reuseables/KickImage';
import { withRouter } from "react-router-dom"
import { connect } from 'react-redux'

/* IMPORT UTILS */
import {
  getCloudImageUrl,
  emptyImage,
  convertToRupiah,
  dustBag,
  boxHandbag,
  boxCondition,
  detailCondition,
  defectCondition,
  handbagCondition,
  sneakersCondition,
  accessoriesCondition,
  detailHandbagCondition,
  formatCurrency
} from "../../../../utils/Helpers"

const OrderDetails = ({
  payment,
  product,
  addonProduct,
  sell,
  dataUserCurrency
}) => {
  const { product_variant_images, display_name, product: product_ = {} } = product || {};
  const haveImages =
    product_variant_images !== undefined
      ? product_variant_images.length > 0
      : false;

  const { category = {} } = product_ || {}

  const {
    offer_amount = "",
    administration_fee = "",
    discount = "",
    subsidy_price = "",
    ka_courier_price = "",
    actual_total_amount = "",
    status,
    total_amount = "",
    ka_courier_discount = "",
    total_adjusted_amount = "",
    scredit_amount = "",
    lbalance_amount = "",
    wallet_amount = "",
    payment_method = ""
  } = payment || {}

  const addonProductArr = payment?.ka_courier_option.split(" + ")

  const filteredProductAddOn = addonProduct?.length > 0 && addonProduct?.filter(addon => addonProductArr.includes(addon.name))

  const renderSize = () => {
    const {
      size,
      sneakers_condition
    } = sell || {}

    const isVilla = () => {
      const DETERMINED_KEYWORD = "FILA";

      if (!display_name) return;

      return display_name
        .toLowerCase()
        .includes(DETERMINED_KEYWORD.toLowerCase());
    };

    const isSneakers = isVilla() && category === "sneakers";
    const isApparels = isVilla() && category === "apparels";
    const sneakerSize = !size?.cm ? "" : size?.cm;
    const apparelSize = !size?.US ? "" : `US ${size?.US}`;

    const isHandbag = _handbagCondition(sneakers_condition)

    const sizeForDesc = (() => {
      if (category.name === "handbags" || category.name === "lifestyles") {
        return apparelSize === "All Size"
          ? `${isHandbag && isHandbag.toLowerCase()} ${apparelSize}`
          : isHandbag ? `${isHandbag && isHandbag.toLowerCase()}` : apparelSize;
      } else if (isSneakers) {
        return sneakerSize;
      } else {
        return apparelSize;
      }
    })();

    return sizeForDesc
  }

  const _handbagCondition = (sneaker_condition) => {
    switch (sneaker_condition) {
      case "BARU":
        return "BRAND NEW";
      case "PRISTINE":
        return "PRISTINE";
      case "GOOD":
        return "GOOD";
      case "WELL_USED":
        return "WELL USED";
      case "LIKE_NEW":
        return "LIKE NEW";
      case "VINTAGE":
        return "VINTAGE";
      default:
        return "";
    }
  }

  const handleProductConditions = () => {
    const {
      missing_accessories,
      sneakers_defect,
      sneakers_condition,
      yellowing,
      display_item,
      defects,
      box_condition,
      hide_box_info,
      sneaker_condition
    } = sell || {}

    const uniqueDefects = _.uniqBy(defects, "name");
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find(a => a.name === "DUST_BAG")
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find(a => a.name === "BOX")
      : {};
    const boxConditionNew = hide_box_info
      ? null
      : boxCondition(box_condition);
    const productDefects = uniqueDefects.length > 0 ? uniqueDefects.filter(item => item.value).map(item => item.display_name) : [];

    const generalConditions = [
      sneakersCondition(sneakers_condition),
      boxConditionNew,
      accessoriesCondition(missing_accessories),
      yellowing ? "Yellowing" : null,
      sneakers_defect ? "Defect" : null,
      display_item ? "Display Item" : null
    ];
    const ProductConditions = [...generalConditions, ...productDefects];
    const productConditionDetail = ProductConditions
      .filter(item => item !== null)
      .map(item => item)
      .join(", ");

    const luxuryDetailArr = [
      sneakersCondition(sneakers_condition),
      accessoriesCondition(missing_accessories),
      dustBag(dustBagCondition && dustBagCondition.value),
      boxHandbag(boxConditions),
      sneakers_defect ? handbagCondition(uniqueDefects) : ""
    ];
    const luxuryDetail = luxuryDetailArr
      .filter(item => item !== "" && item !== "Missing Box")
      .map(item => item)
      .join(", ");

    return category.name === "handbags" ? luxuryDetail : productConditionDetail
  };

  const isOnlyKickPoint = payment_method === "kick_point";
  const userCurrency = isOnlyKickPoint? {
    ...dataUserCurrency,
    currency: "KP"
  } : dataUserCurrency;

  return (
    <div id="invoice-responsive-order-summary">
      <div className="collapse-summary-wrapper">
        <div className="order-cards-wrapper">
          <div className="order-title-wrapper">
            <h3 className="order-title">
              Order Details
            </h3>
          </div>
          <div className="card-list-wrapper">
            {/* MAIN PRODUCT ITEM */}
            <div className="order-card-wrapper">
              <div className="order-inner-wrapper">
                <div className="card-image-wrapper">
                  {haveImages ? <KickImage
                    src={getCloudImageUrl(product_variant_images[0].URL)}
                    alt="..."
                  /> : <KickImage src={emptyImage(category.name)} alt="..." />
                  }
                </div>
                <div className="description-wrapper">
                  <div className="desc-wrapper">
                    <p>
                      {display_name}
                    </p>
                    <p>
                      {renderSize()} / {handleProductConditions()}
                    </p>
                  </div>
                  <div className="price-quantity-wrapper">
                    <p>{formatCurrency(parseInt(offer_amount), userCurrency.ratio, userCurrency.currency)}</p>
                    <p>Qty 1</p>
                  </div>
                </div>
              </div>
            </div>

            {/* ADD ONS ITEM */}
            {filteredProductAddOn.length > 0 &&
              filteredProductAddOn.map(addon => {
                const { img_url, display_name, description, price } = addon;
                return (
                  <div className="order-card-wrapper">
                    <div className="order-inner-wrapper">
                      <div className="card-image-wrapper">
                        {img_url ? (
                          <KickImage src={img_url} alt="..." />
                        ) : (
                          <KickImage src={emptyImage("sneakers")} alt="..." />
                        )}
                      </div>
                      <div className="description-wrapper">
                        <div
                          className="desc-wrapper">
                          <p>{display_name}</p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: description,
                            }} />
                        </div>
                        <div className="price-quantity-wrapper">
                          <p>{formatCurrency(parseInt(price), userCurrency.ratio, userCurrency.currency)}</p>
                          <p>Qty 1</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className="payment-summary-wrapper">
          <div className="payment-container inner-summary-wrapper">
            <div className="right-bag-content-summary-row summary-title">
              <p>Payment Summary</p>
            </div>
            <div className="right-bag-content-summary-row">
              <p>Product Price</p>
              <p>{formatCurrency(parseInt(offer_amount), userCurrency.ratio, userCurrency.currency)}</p>
            </div>
            {parseInt(administration_fee) > 0 && <div className="layanan-price right-bag-content-summary-row">
              <p>Administration Fee</p>
              <p>{formatCurrency(parseInt(administration_fee), userCurrency.ratio, userCurrency.currency)}</p>
            </div>}
            {parseInt(ka_courier_price) > 0 && <div className="shipping-fee right-bag-content-summary-row">
              <p>Shipping &#38; Handling</p>
              <p>{formatCurrency(parseInt(ka_courier_price), userCurrency.ratio, userCurrency.currency)}</p>
            </div>}
            {parseInt(discount) > 0 && <div className="discount right-bag-content-summary-row">
              <p>Voucher Code</p>
              <p>{formatCurrency(parseInt(discount), userCurrency.ratio, userCurrency.currency)}</p>
            </div>}
            {parseInt(subsidy_price) > 0 && <div className="subsidy-price right-bag-content-summary-row">
              <p>
                Discount &#40;<span>Automatically applied</span>&#41;
              </p>
              <p>{formatCurrency(parseInt(subsidy_price), userCurrency.ratio, userCurrency.currency)}</p>
            </div>}
            {parseInt(ka_courier_discount) > 0 && <div className="total-addon-price right-bag-content-summary-row">
              <p>Promo Product</p>
              <p>{formatCurrency(parseInt(ka_courier_discount), userCurrency.ratio, userCurrency.currency)}</p>
            </div>}
            {wallet_amount && <div className="shipping-fee credit-usage right-bag-content-summary-row">
              <p>Kick Credit Usage</p>
              <p>- {formatCurrency(parseInt(wallet_amount), userCurrency.ratio, userCurrency.currency)}</p>
            </div>}
            {scredit_amount && <div className="shipping-fee credit-usage right-bag-content-summary-row">
              <p>Seller Credit Usage</p>
              <p>- {formatCurrency(parseInt(scredit_amount), userCurrency.ratio, userCurrency.currency)}</p>
            </div>}
            {lbalance_amount && <div className="shipping-fee kick-points right-bag-content-summary-row">
              <p>Kick Points Usage</p>
              <p>- {formatCurrency(parseInt(lbalance_amount), userCurrency.ratio, userCurrency.currency)}</p>
            </div>}
            <div className="total-price right-bag-content-summary-row">
              <p>Amount to be paid</p>
              <p>{formatCurrency(parseInt(total_adjusted_amount), userCurrency.ratio, userCurrency.currency)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  dataUserCurrency: state.dataAuth.userCurrency
})

export default connect(mapStateToProps, null)(withRouter(OrderDetails))